const SettlementInfo = () => {
	return (
		<div className={`settlement-info-div`}>
			<div className={`settle-info-each`}>
				<p className={`settle-title`}>정산정보</p>
				<div className={`settle-image-group`}>
					<img
						src={`/assets/images/report/account.png`}
						alt={`화살표`}
						style={{
							height: "2.5em",
							width: "auto",
						}}
					/>
					<div className={`settle-image-description`}>
						<p className={`sub`}>정산방식</p>
						<p>계좌이체</p>
					</div>
				</div>

				<div className={`settle-image-group`}>
					<img
						src={`/assets/images/report/month.png`}
						alt={`화살표`}
						style={{
							height: "2.5em",
							width: "auto",
						}}
					/>
					<div className={`settle-image-description`}>
						<p className={`sub`}>정산주기</p>
						<p>월 정산</p>
					</div>
				</div>

				<div className={`settle-image-group`}>
					<img
						src={`/assets/images/report/date.png`}
						alt={`화살표`}
						style={{
							height: "2.5em",
							width: "auto",
						}}
					/>
					<div className={`settle-image-description`}>
						<p className={`sub`}>정산예정일</p>
						<p>정산기준일(15일)+1 영업일</p>
					</div>
				</div>
			</div>
			<div className={`settle-info-each`}>
				<p className={`settle-title`}>수수료율</p>

				<div className={`settle-image-group`}>
					<img
						src={`/assets/images/report/fee.png`}
						alt={`화살표`}
						style={{
							height: "2.5em",
							width: "auto",
						}}
					/>
					<div className={`settle-image-description`}>
						<p className={`sub`}>구매 수수료율</p>
						<p>
							N% <span>(브랜드사의 설정에 따라 달라집니다)</span>
						</p>
					</div>
				</div>
			</div>
			<div className={`settle-info-each-column`}>
				<p className={`title`}>정산 프로세스 안내</p>
				<ul>
					<li>
						정산 프로세스는 정산요청 > 정산요청 중 > 정산완료 순으로 진행됩니다.
					</li>
					<li>
						정산요청 : 월별정산탭에서 매월 5~10일 정산예정 금액을
						'정산요청(파란색 버튼, 활성화)'하실 수 있습니다.{"\n"}
						세부내역은 건별정산탭에서 확인하실 수 있습니다.
					</li>
					<li>
						정산요청 중 : 개인회원은 확정수익에서 원천세 3.3%를 제한 금액이,
						사업자 회원은 확정된 수익만큼 정산됩니다.
						{/*사업자 회원은 확정수익에서 부가가치세 10%를 더한 금액이 정산됩니다.*/}
						{"\n"}
						사업자 회원은 정산요청 이후 정산금액(부가세 포함)에 대해 주식회사
						하우투약(사업자번호 : 774-88-01428) 으로 세금계산서를 발행해주세요.
					</li>
					<li>
						정산완료 : 정산기준일(15일) + 1영업일 오전에 입금이 완료됩니다.
					</li>
					<li>
						수수료율은 구매 된 제품의 브랜드사에서 설정하는 퍼센트(%)로
						측정됩니다.
					</li>
					<li>수수료율은 구매 시점에 설정된 수수료율로 계산됩니다.</li>
				</ul>
			</div>
		</div>
	);
};
export default SettlementInfo;
